import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { Guid } from "client_legacy/ndaw/guid";

enum RssFeedType {
	Public = 0,
	SharePoint = 1
}

interface RssItemModel {
	title: string;
	publishDate: string;
	url: string;
	imageUrl: string;
	description: string;
	category: string;
}

function getFeed(tileId: number, tabId: Guid): Promise<RssItemModel[]> {
	return httpClient.get<RssItemModel[]>("/Workspace/LiveInformation/Rss/Feed", {tileId, tabId});
}

export {
	getFeed,
	RssFeedType,
	type RssItemModel
};